var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sdfdff"},[_c('img',{attrs:{"src":require("@/assets/img-pc/v31.0808a585.svg")}}),_c('swiperMode',{ref:"swiperModeRef",staticClass:"flex-1",attrs:{"list":_vm.notices,"delay":5000}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ckgd",staticStyle:{"margin-left":"auto"}},[_c('img',{attrs:{"src":require("@/assets/img-pc/v32.03c79cb9.svg")}})])
}]

export { render, staticRenderFns }